import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';

import SearchResults from './SearchResults';

function buildResourceString(obj) {
  return Object.keys(obj)
    .map((param) => `resources[${param}]=${obj[param]}`)
    .join('&');
}

/* eslint-disable jsx-a11y/control-has-associated-label, eslint-comments/disable-enable-pair */
function SearchModal() {
  const [searchTerm, setSearchTerm] = useState();
  const [results, setResults] = useState({products: [], pages: [], articles: []});
  const [showResults, setShowResults] = useState(false);

  const rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;

  const resources = {
    type: window.searchSettings.types.join(','),
    limit: window.searchSettings.limit,
  };
  const unavailableProducts = window.searchSettings.unavailable_products;
  const enableInstantSearch = window.searchSettings.enableInstantSearch;

  useEffect(() => {
    if (searchTerm) {
      document.body.classList.add('search-performed');
    }
    if (!searchTerm) {
      setShowResults(false);
      document.body.classList.remove('search-performed');
      return;
    }
    if (!enableInstantSearch) {
      return;
    }

    const fetchResults = async () => {
      const resourceString = buildResourceString(resources);
      const url = `${rootUrl}/search/suggest.json?q=${searchTerm}&${resourceString}&resources[options][unavailable_products]=${unavailableProducts}`;
      try {
        const response = await fetch(url);
        if (response.ok === false) {
          throw new Error('Search response was not OK');
        }
        const json = await response.json();
        return json.resources;
      } catch (err) {
        window.console.error(err);
      }
    };

    const updateResults = async () => {
      try {
        const {results: searchResults} = await fetchResults();
        setResults({
          products: searchResults.products || [],
          pages: searchResults.pages || [],
          articles: searchResults.articles || [],
        });
        setShowResults(true);
      } catch (err) {
        window.console.error(err);
      }
    };
    updateResults();
  }, [searchTerm]);

  function handleChange(evt) {
    evt.persist();
    setSearchTerm(evt.target.value);
  }

  function clearInput() {
    setSearchTerm('');
  }

  return (
    <>
      <div className="search-modal__header">
        <h3 className="visually-hidden" id="searchTitle">
          {window.theme.strings.search_submit}
        </h3>
        <form action={`${rootUrl}/search`} method="GET">
          <div className="form__group">
            <div className="search-form__group">
              <input
                name="q"
                id="searchInput"
                type="search"
                value={searchTerm}
                placeholder={window.theme.strings.search_placeholder}
                onChange={handleChange}
                className="search-input"
                aria-label={window.theme.strings.search_placeholder}
              />
              <label htmlFor="searchInput" className="visually-hidden">
                {window.theme.strings.search_placeholder}
              </label>
              <input id="HideSearchItems" type="hidden" name="type" value="product" />
              <button
                type="button"
                onClick={clearInput}
                className={
                  enableInstantSearch
                    ? 'btn btn--text btn--clear-search'
                    : 'btn btn--text btn--clear-search predictive-disabled'
                }
              >
                {window.theme.strings.search_clear}
              </button>
              <button
                type="submit"
                className={enableInstantSearch ? 'visually-hidden' : 'btn btn--small'}
                tabindex="-1"
              >
                {window.theme.strings.search_submit}
              </button>
            </div>
          </div>
        </form>
      </div>
      {showResults && <SearchResults results={results} searchTerm={searchTerm} />}
    </>
  );
}

ReactDOM.render(<SearchModal />, document.getElementById('SearchModal__form'));
